import React from 'react';
import { useTranslation } from 'react-i18next';
import { Select, MenuItem } from '@material-ui/core';

import { MyTimePicker } from '../FormWidgets/DatePicker.js';
import { multiIOHwTypeMappping } from '../Constants/constants.js';

export function OverwrIOSelect({ select, type, onChange, controller, parent, ...other }) {
  const { t } = useTranslation();
  const resolvedType = typeof type === 'number' ? multiIOHwTypeMappping[type] : type;
  const analog = resolvedType === 'analog_out';
  const mode = Number(select);
  return (
    <Select
      value={mode}
      onChange={onChange}
      disabled={other.disabled}
      inputProps={{ 'aria-label': t('ov_mode') }}
      style={{ minWidth: 140 }}
    >
      <MenuItem value={analog ? 2 : 1}>{t(analog ? 'ov_enable' : 'ov_on')}</MenuItem>
      {!analog && <MenuItem value={3}>{t('ov_off')}</MenuItem>}
      <MenuItem value={0}>{t('ov_auto')}</MenuItem>
      {/* Preserve legacy forced ON/OFF readback without treating it as Auto. */}
      {analog && (mode === 1 || mode === 3) && (
        <MenuItem value={mode} disabled>
          {t(mode === 1 ? 'ov_on' : 'ov_off')}
        </MenuItem>
      )}
    </Select>
  );
}

export function OverwrIOTimeout({ timeout, onChange, controller, parent, ...other }) {
  let { t } = useTranslation();

  const handleChange = (value, event) => {
    onChange(event ?? null, value);
  };

  return (
    <React.Fragment>
      <MyTimePicker
        value={timeout}
        seconds={true}
        nonZero={true}
        name="timeout"
        onChange={handleChange}
        initialFocusedDate={new Date('1995-07-21T00:30:00')}
        placeholder={t('no_overwr_timeout')}
        disabled={other.disabled}
      />
    </React.Fragment>
  );
}
